import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserAccountRegDto } from 'src/app/core/dtos/dto';
import { BrandEnum, RegStatusEnum, TestTypeEnum } from 'src/app/core/dtos/enum';


@Component({
  selector: 'app-upcoming-test',
  templateUrl: './upcoming-test.component.html',
  styleUrls: ['./upcoming-test.component.scss']
})
export class UpcomingTestComponent implements OnInit {

  @Input() upcomingRegistration: UserAccountRegDto;
  @Input() brandId: BrandEnum;
  @Input() launchSRDownload: boolean;
  @Input() regPoliciesUrl: string;
  @Input() testDayInfoUrl: string;
  @Output() confirmEmail = new EventEmitter<UserAccountRegDto>();

  saftTypeId = TestTypeEnum.SAFT;
  registrationManualApprovalRequired: boolean;
  caelCETestTypeId = 10;
  isRegBiometricConsentActive: string;

  constructor(
  ) { }

  ngOnInit(): void {
    this.registrationManualApprovalRequired = (this.upcomingRegistration.regStatusEnum === RegStatusEnum.RegistrationManualApprovalRequired);
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  resendEmail(reg: UserAccountRegDto) {
    this.confirmEmail.emit(reg);
  }

}
